import React from "react";
import { Typography } from "@mui/material";

type DataLoaderProps<T> = {
  isLoading: boolean;
  error: unknown;
  data: T | undefined | null;
  loadingComponent?: React.ReactNode;
  errorComponent?: React.ReactNode;
  emptyComponent?: React.ReactNode;
  children: (data: T) => React.ReactNode;
};

function DataLoader<T>({
  isLoading,
  error,
  data,
  loadingComponent = <Typography>Loading...</Typography>,
  errorComponent = <Typography color="error">Something went wrong.</Typography>,
  emptyComponent = <Typography>No data found.</Typography>,
  children,
}: DataLoaderProps<T>) {
  if (isLoading) return <>{loadingComponent}</>;
  if (error) return <>{errorComponent}</>;
  if (!data || (Array.isArray(data) && data.length === 0)) {
    return <>{emptyComponent}</>;
  }

  return <>{children(data)}</>;
}

export default DataLoader;
